import React from 'react';
import Card from '../../../core/layout/Card';
import Separator from '../../../core/layout/Separator';
import DraftItemExtraColumnsContainer from './DraftItemExtraColumnsContainer';
import ColumnSeparator from '../../../core/layout/ColumnSeparator';
import DraftItemListBatchActionsContainer from './DraftItemListBatchActionsContainer';
import Tabs from '../../../core/layout/Tabs';
import DraftItemListContainer from './DraftItemListContainer';
import DraftItemListFilterContainer from './DraftItemListFilterContainer';
import DraftItemListService from '../services/DraftItemListService';
import { Roles } from '../../../core/util';

const DraftItemListScene = () => (
  <Tabs
    onChange={(tab) => DraftItemListService.init(tab)}
    tabs={[
      {
        key: 'course',
        title: 'Unit / Mastery',
        content: (
          <div>
            <Card title="Draft Items Filters">
              <DraftItemListFilterContainer />
            </Card>
            <Separator />
            <Card
              title="Draft Items"
              actions={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <DraftItemExtraColumnsContainer />
                  <ColumnSeparator size="xs" />
                  <DraftItemListBatchActionsContainer />
                </div>
              }
            >
              <DraftItemListContainer type="course" />
            </Card>
          </div>
        ),
      },
      ...([Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role)
        ? [
            {
              key: 'placement',
              title: 'Placement Test',
              content: (
                <div>
                  <Card title="Draft Items Filters">
                    <DraftItemListFilterContainer />
                  </Card>
                  <Separator />
                  <Card
                    title="Draft Items"
                    actions={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <DraftItemExtraColumnsContainer />
                        <ColumnSeparator size="xs" />
                        <DraftItemListBatchActionsContainer />
                      </div>
                    }
                  >
                    <DraftItemListContainer type="placement" />
                  </Card>
                </div>
              ),
            },
            {
              key: 'certification',
              title: 'Certification Test',
              content: (
                <div>
                  <Card title="Draft Items Filters">
                    <DraftItemListFilterContainer />
                  </Card>
                  <Separator />
                  <Card
                    title="Draft Items"
                    actions={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <DraftItemExtraColumnsContainer />
                        <ColumnSeparator size="xs" />
                        <DraftItemListBatchActionsContainer />
                      </div>
                    }
                  >
                    <DraftItemListContainer type="certification" />
                  </Card>
                </div>
              ),
            },
          ]
        : []),
    ]}
  />
);

export default DraftItemListScene;
